export enum ReportType {
    'ProductReport' = 1,
    'ColumnReport' = 2,
    'RepairInProgress' = 3,
    'PerMonthReport'=4,
    'PerMonthByProductTypeReport'=5,
    'AverageTimeInstatusDataReport'=6
}

export enum ExportType {
    CSV = 1,
    Excel = 2
}